// 基础资料-品牌列表
export const search = {
  inputs: [
    // 信息列数不多，故不要筛选项区域
  ],
  lines: [
    {
      prop: 'name',
      label: 'Brand Name',
      width: 160
    },
    {
      prop: 'presented_to_csr',
      label: 'presented to CSR',
      width: 150
    },
    {
      prop: 'created_at',
      label: 'Create Date',
      width: 130
    },
    {
      prop: 'updated_at',
      label: 'Modify Date',
      width: 130
    }
    // 品牌资料不需要点击详情进行查看操作，因为信息量少
  ]
}
// 不提供编辑页面、新增页面。品牌编辑的几率几乎没有。新增则在数据库中操作
export default { search }
